import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import React from 'react';
import { HashRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import appInfo from './app-info';
import { navigation } from './app-navigation';
import routes from './app-routes';
import './App.scss';
import './dx-styles.scss';
import { Footer } from './components';
import {
    SideNavInnerToolbar as SideNavBarLayout,
    SingleCard
} from './layouts';
import { sizes, subscribe, unsubscribe } from './utils/media-query';
import SecureLS from "../node_modules/secure-ls/dist/secure-ls";
import eprlogo from "./media/epr.png"
import sbclogo from "./media/sb_cologo-full_color_300.png"
import CompatibleBrowserMessage from "./components/browserdetect/compatiblebrowsermessage.js"
import NoBotMessage from "./components/browserdetect/nobotmessage.js"
import { initGA, GApageView } from '.';
import { useAuth0 } from "@auth0/auth0-react";
//import { Button } from 'devextreme-react/button';
import { useState, useEffect } from 'react';
import { sendRequest } from './_helper/util.js';

const url = process.env.REACT_APP_API_URL + "/api";
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
/*
const trackingId = "UA-75182977-7"; 
ReactGA.initialize(trackingId);
ReactGA.pageview('/homepage');*/


//const LoginContainer = ({ logIn }) => <LoginForm onLoginClick={logIn} />;

//const NotAuthPage = (props) => {
//    const { loginWithRedirect } = useAuth0();

//    GApageView("/loginpage");
//    return (
//        <React.Fragment>
//            <SingleCard>
//                {/*<Route render={() => <LoginContainer {...props} />} />*/}

//                <div
//                    style={{
//                        fontSize: "16px",
//                        textAlign: "center",
//                        display: "table",
//                        margin: "0 auto",
//                        marginBottom:"50px"
//                    }}
//                >
//                    <h4>E-Payroll Dropbox</h4>
//                    <Button text="Log In"
//                        icon="user"
//                        type="normal"
//                        stylingMode="contained"
//                        onClick={() => loginWithRedirect()}>
//                    </Button>
//                </div>

//                <Footer>
//                    {(new Date().getFullYear())} San Bernardino County Auditor-Controller/Treasurer/Tax Collector.<br />Contact Central Payroll at (909) 382-3154
//                </Footer>
//            </SingleCard>
//        </React.Fragment>
//    );
//};

const AuthPage = (props) => {
    GApageView("/uploaderpage");
    return (
        <SideNavBarLayout menuItems={navigation} title={appInfo.title} {...props}>
            <Routes>
                {routes.map(item => (
                    <Route
                        exact
                        key={item.path}
                        path={item.path}
                        element={item.element}
                    />
                ))}
                <Route path="*" element={<Navigate to="/uploadfile" replace />} />
            </Routes>
            <Footer>
                {(new Date().getFullYear())} San Bernardino County Auditor-Controller/Treasurer/Tax Collector.<br />Contact Central Payroll at (909) 382-3154
            </Footer>
        </SideNavBarLayout>
    );
};

const { detect } = require('detect-browser');
const browser = detect();

const App = () => {
    const getScreenSizeClass = () => {
        const screenSizes = sizes();
        return Object.keys(screenSizes).filter(cl => screenSizes[cl]).join(' ');
    };

    const isBrowserOk = () => {
        if (browser) {
            switch (browser.type) {
                case 'bot':
                    return -1;
                case 'bot-device':
                    return -2;
                case 'browser':
                    switch (browser.name) {
                        case 'chrome':
                            return browser.version <= 72 ? 0 : 1;
                        case 'safari':
                            return browser.version <= 12 ? 0 : 1;
                        case 'ios':
                            return browser.version <= 12 ? 0 : 1;
                        case 'firefox':
                            return browser.version <= 68 ? 0 : 1;
                        case 'edge-chromium':
                            return browser.version <= 83 ? 0 : 1;
                        default:
                            return 0;
                    }
                case 'node':
                    return -3;
                default:
                    return -3;
            }
        }
        return 0;
    };

    const [loggingIn, setLoggingIn] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [screenSizeClass, setScreenSizeClass] = useState(getScreenSizeClass());
    const [browserOk, setBrowserOk] = useState(0);

    const { isLoading, isAuthenticated, user, getAccessTokenSilently, logout, loginWithRedirect } = useAuth0();

    useEffect(() => {
        initGA();
        setBrowserOk(isBrowserOk());
        subscribe(screenSizeChanged);
        return () => {
            unsubscribe(screenSizeChanged);
        };
    }, []);

    useEffect(() => {
        const getUserFromDB = () => {
            try {
                getAccessTokenSilently({
                    authorizationParams: {
                        audience: audience,
                        //scope: scope,
                    },
                }).then((accessToken) => {
                    setLoggingIn(true);

                    const myObj = { email: user.email };
                    const body = JSON.stringify(myObj);
                    sendRequest(url + '/Users/authenticate', 'POST', body, accessToken).then(myJson => {
                        if (typeof myJson.error !== "undefined") {
                            alert(`Access denied. Please contact adminsitrator.`);
                            logOut();
                        }
                        else {

                            const ls = new SecureLS();
                            ls.set('userinfo', myJson);
                            setLoggedIn(true);
                            setLoggingIn(false);
                        }

                    });


                });

            } catch (e) {
                console.log(e.message);
            }
        };

        if (browserOk !== 1) return;
        if (isLoading) return;
        if (!isAuthenticated) { loginWithRedirect(); return }
        getUserFromDB();

    }, [isLoading, isAuthenticated, getAccessTokenSilently, user, logout]);



    const screenSizeChanged = () => {
        setScreenSizeClass(getScreenSizeClass());
    };

    //const logIn = () => {
    //    setLoggedIn(true);
    //};

    const logOut = () => {
        const ls = new SecureLS();
        ls.removeAll();
        setLoggedIn(false);
        setLoggingIn(false);

        //logout Auth0
        logout({ logoutParams: { returnTo: window.location.origin } });
    };

    const userMenuItems = [
        {
            text: 'Logout',
            icon: 'fas fa-sign-out-alt',
            onClick: logOut
        }
    ];

    const BrowserNotOk = () => {
        GApageView("/browsernotok");
        return (
            <SingleCard>
                <CompatibleBrowserMessage />
            </SingleCard>
        );
    };

    const BotNotWelcome = () => {
        GApageView("/nobot");
        return (
            <SingleCard>
                <NoBotMessage />
            </SingleCard>
        );
    };
    const Loading = () => {
        return (
            <SingleCard>
                <div>Loading...</div>
            </SingleCard>
        )
    };

    return (
        <div className={`app ${screenSizeClass}`}>
            <Router>
                {loggedIn ? (
                    <AuthPage userMenuItems={userMenuItems} />
                ) : (
                    <div className={'logincontainer'}>
                        <div id={'Logon_UPHeader'}>
                            <div className={'white borderBottom width100'} id={'headerTableDiv'}>
                                <div className={'paddings sizeLimit'}>
                                    <table id={'headerTable'} className={'headerTable xafAlignCenter white width100 sizeLimit'}>
                                        <tbody>
                                            <tr>
                                                <td valign="middle">
                                                    <a id="Logon_LogoLink" href="/">
                                                        <img src={eprlogo} alt={'ATC Dropbox'} className={'eprlogo'} />
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className={'loginsection'}>
                            <img src={sbclogo} className={'sbclogo'} alt={'ATC Dropbox'} />
                        </div>
                            {browserOk === 1
                                ?
                                loggingIn
                                    ?<Loading />
                                    :null//<NotAuthPage />
                                :
                                browserOk < 0
                                    ? <BotNotWelcome />
                                    : <BrowserNotOk />
                            }
                    </div>
                )}
            </Router>
        </div>
    );
};

export default App;

